import{createContext as r}from"react";var o=r();export{o as DevCenterRouterContext};
